import {
  takeLatest, call, put,
} from 'redux-saga/effects';
import axios from '../axiosConfig';
import {
  bookTripFailure, acceptTripPriceChangeRequest, acceptTripPriceChangeSuccess,
} from '../../slices/trip';

const queryString = require('query-string');

function* acceptTripPriceChangeWorker({
  payload: {
    tripId,
  },
}) {
  try {
    const request = {
      tripId,
      timestamp: Date.now(),
    };
    const url = `/trips/acceptPriceChange?${queryString.stringify(request, { skipNull: true })}`;
    const config = {
      method: 'get',
      url,
    };
    yield call(axios, config);
    yield put(acceptTripPriceChangeSuccess());
  } catch (error) {
    let errorMsg = 'There is problem with your request. please try again later.';
    if (error && error.response) {
      if (error.response.status === 406) {
        // Trip updated exception (from api it will return NotAcceptable response status)
        yield put(bookTripFailure({
          error: 'Your trip availability/price is changed!',
          isTripAvailabilityPriceChanged: true,
          tripAvailabilityPriceChangeResponse: error.response.data,
        }));
      } else {
        errorMsg = `${error.response.data.title || ''} ${error.response.data.detail || ''}`;
      }
    } else if (error && typeof (error) === 'object' && error.message) {
      errorMsg = `There is problem with your request. please try again later. ${error.name}: ${error.message} (${error.code}).`;
    }
    yield put(acceptTripPriceChangeSuccess({
      error: errorMsg,
    }));
  }
}

function* acceptTripPriceChangeWatcher() {
  yield takeLatest(acceptTripPriceChangeRequest.toString(), acceptTripPriceChangeWorker);
}

export default acceptTripPriceChangeWatcher;
